import { render } from "./language_selector.vue?vue&type=template&id=38687382&scoped=true"
import script from "./language_selector.vue?vue&type=script&lang=js"
export * from "./language_selector.vue?vue&type=script&lang=js"

import "./language_selector.vue?vue&type=style&index=0&id=38687382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38687382"]])

export default __exports__